<template>
  <div class="lotes-popup">

    <!-- Lista -->

    <LotesList2
      ref='loteslist2'
      v-if="lotesList.show"
      :user="user"
      :idis="lotesList.idis"
      :id_lote="newLote.id"
      :tipo_lote="newLote.tipo_lote_selected.id"
      :permisos="permisos"
      :show_only='showOnly'
      @hidden="lotesList.show=false"
      @deleteFromLote="deleteFromLote"
      @deleteFromParametrizadoLote="deleteFromParametrizadoLote"

    ></LotesList2>

    <!-- Solapados -->

    <LotesListSolapados
      ref='loteslistsolapados'
      v-if="lotesListSolapados.show"
      :user="user"
      :idis="lotesListSolapados.idis"
      :id_lote="newLote.id"
      :tipo_lote="newLote.tipo_lote_selected.id"
      :permisos="permisos"
      :show_only='showOnly'
      @hidden="lotesListSolapados.show=false"
      @deleteFromLote="deleteFromLote"
      @deleteFromParametrizadoLote="deleteFromParametrizadoLote"

    ></LotesListSolapados>

    <!-- Add establecimientos -->

    <b-modal
      class="fixedModal"
      ref="addEstablecimientoModal"
      size="md"
      id="addEstablecimientoModal"
      title="Añadir establecimientos"
      centered
      @ok="addEstablecimientoModalOkSync"
    >
      <template slot="modal-ok">Aceptar</template>

      <template slot="modal-cancel">Cancelar</template>
      <b-row>
        <b-col :cols="12">
          <b-form-group
            id="exampleInputGroup1"
            label="IDIs Establecimientos"
            label-for="exampleInput1"
            description="Separados por saltos de línea"
          >
            <b-form-textarea
              width="100%"
              :rows="8"
              v-model="addEstablecimientoModal.textarea"
              class="mb-3"
            />
          </b-form-group>
          <span
            v-if="addEstablecimientoModal.error"
            class="error"
          >{{ addEstablecimientoModal.error }}</span>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Show establecimientos -->

    <b-modal
      ok-only
      class="fixedModal"
      ref="showEstablecimientoModal"
      size="md"
      id="showEstablecimientoModal"
      title="Listado de establecimientos"
      centered
    >
      <template slot="modal-ok">Cerrar</template>

      <b-row>
        <b-col :cols="12">
          <b-form-group id="exampleInputGroup1" label="Listado de IDIs" label-for="exampleInput1">
            <b-form-textarea
              width="100%"
              :rows="8"
              :value="newLote.filtro_manual.join('\r\n')"
              class="mb-3"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Remove establecimientos -->

    <b-modal
      class="fixedModal"
      ref="removeEstablecimientoModal"
      size="md"
      id="removeEstablecimientoModal"
      title="Quitar establecimientos"
      centered
      @ok="removeEstablecimientoModalOk"
    >
      <template slot="modal-ok">Aceptar</template>

      <template slot="modal-cancel">Cancelar</template>
      <b-row>
        <b-col :cols="12">
          <b-form-group
            id="exampleInputGroup1"
            label="IDIs Establecimientos"
            label-for="exampleInput1"
            description="Separados por saltos de línea"
          >
            <b-form-textarea
              width="100%"
              :rows="8"
              v-model="removeEstablecimientoModal.textarea"
              class="mb-3"
            />
          </b-form-group>
          <span
            v-if="removeEstablecimientoModal.error"
            class="error"
          >{{ removeEstablecimientoModal.error }}</span>
        </b-col>
      </b-row>
    </b-modal>

    <div class="popstyle2" v-if="!hideModalflag">
      <b-modal
        class="fixedModal"
        ref="modalLotes"
        size="lg"
        id="modal1"
        :title="modalTitle"
        centered
        :hide-footer="true"
        @hidden="onHidden"
      >
        <div v-if="loading_table">
          <Loader :delay="0"></Loader>
        </div>
        <div v-else class="scroll">
          <template v-if="!loteForm">
            <b-row>
              <b-col>
                <b-form-checkbox
                  style="margin-left: 1rem;"
                  v-model="toMe"
                  @input="updateTable"
                  :disabled="limitedPermision()"
                >Ver lotes asignados a mí</b-form-checkbox>
              </b-col>
              <b-col v-if="!limitedPermision()">
                <b-form-checkbox v-model="forMe" @input="updateTable">Ver lotes asignados por mí</b-form-checkbox>
              </b-col>
            </b-row>
            <b-button
              class="mt-3"
              @click="initAddLote"
              v-if="hasPermision({rol: 'GESTION COMERCIAL'}, 'E') && !limitedPermision()"
            >Añadir lote</b-button>
            <Table
              v-if="!loading_table"
              class="hideFilter mt-2 lotes-table"
              url="lotes/"
              ref="table"
              :options="options"
              :columns="columns"
              @edit="editLote"
            ></Table>
          </template>
          <template v-else>
            <b-card class="text-center" style="border-color: #7b7b7b;">
              <h2>Datos lote</h2>

              <!-- Inicio reestructuración -->
              <b-row>
                <b-col lg="9">
                  <b-row>
                    <b-col lg="2" v-if="newLote.id">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Código lote">
                          <b-form-input v-model="newLote.id" disabled></b-form-input>
                        </b-form-group>
                      </b-form>
                    </b-col>
                    <b-col :lg="(newLote.id ? 2 : 3)">
                      <b-form>
                        <b-form-group id="tipolote" label="Tipo Lote:" label-for="tipoloteinput">
                          <multiselect
                            v-model="newLote.tipo_lote_selected"
                            :options="tipos_lotes"
                            id="tipoloteinput"
                            class="mb-3"
                            :allowEmpty="false"
                            placeholder
                            label="label"
                            :disabled="showOnly"
                            track-by="id"
                            preselect-first
                          />
                        </b-form-group>
                      </b-form>
                    </b-col>
                    <b-col :lg="(newLote.id ? 2 : 2)">
                      <b-form>
                        <b-form-group
                          id="metodolote"
                          label="Método Lote:"
                          label-for="metodoloteinput"
                        >
                          <multiselect
                            v-model="newLote.metodo_lote_selected"
                            :options="metodos_lotes"
                            id="metodoloteinput"
                            @input='changedMetodoLote'
                            class="mb-3"
                            :allowEmpty="false"
                            placeholder
                            :disabled="showOnly"
                            label="label"
                            track-by="id"
                            preselect-first
                          />
                        </b-form-group>
                      </b-form>
                    </b-col>
                    <b-col :lg="(newLote.id ? 2 : 3)">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Status">
                          <b-form-input v-model="newLote.status" disabled></b-form-input>
                        </b-form-group>
                      </b-form>
                    </b-col>

                    <b-col lg="2">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Fecha inicio prevista">
                          <datetime
                            v-model="newLote.fecha_inicio_prevista"
                            @input="changedFechaInicio"
                            input-class="form-control"
                            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                            type="date"
                            :auto="true"
                            value-zone="local"
                            zone="local"
                            v-validate="'required'"
                            name="Fecha inicio prevista"
                            :disabled="showOnly"
                          ></datetime>
                          <span class="error">{{ errors.first('Fecha inicio prevista') }}</span>
                        </b-form-group>
                      </b-form>
                    </b-col>
                    <b-col lg="2">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Fecha cierre prevista">
                          <datetime
                            id="fecha_cierre_prevista"
                            v-model="newLote.fecha_cierre_prevista"
                            @input="changedFechaCierre"
                            input-class="form-control"
                            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                            type="date"
                            :auto="true"
                            value-zone="local"
                            zone="local"
                            v-validate="'required'"
                            name="Fecha cierre prevista"
                            :disabled="showOnly"
                          ></datetime>
                          <span class="error">{{ errors.first('Fecha cierre prevista') }}</span>
                        </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Código asignador">
                          <b-form-input v-model="newLote.usuario_asignador" disabled></b-form-input>
                        </b-form-group>
                      </b-form>
                    </b-col>
                    <b-col lg="3">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Nombre asignador">
                          <b-form-input v-model="nombre_asignador" disabled></b-form-input>
                        </b-form-group>
                      </b-form>
                    </b-col>
                    <b-col lg="7">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Descripción">
                          <b-form-input
                            v-model="newLote.descripcion"
                            v-validate="'required'"
                            name="Descripción"
                            :disabled="showOnly"
                          ></b-form-input>
                          <span class="error">{{ errors.first('Descripción') }}</span>
                        </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col lg="3">
                  <b-row>
                    <b-col lg="12">
                      <b-form>
                        <b-form-group style="font-size: 1rem;" label="Observaciones">
                          <b-form-textarea
                            rows="5"
                            v-validate="'required'"
                            name="Observaciones"
                            v-model="newLote.observaciones"
                            :disabled="showOnly"
                          ></b-form-textarea>
                          <span class="error">{{ errors.first('Observaciones') }}</span>
                        </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- Fin reestructuración -->
            </b-card>
            <br>
            <b-card class="text-center" style="border-color: #7b7b7b;">
              <h2>Asignación</h2>
              <b-form>
                <b-row>
                  <b-col lg="2">
                    <b-form-group style="font-size: 1rem;" label="Código asignado">
                      <b-form-input v-model="newLote.usuario_asignado" disabled></b-form-input>
                      <span class="error">{{ errors.first('Código asignado') }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3">
                    <b-form-group
                      style="font-size: 1rem;"
                      label="Nombre asignado"
                      class="autocomplete"
                    >
                      <b-form-input
                        autocomplete="off"
                        v-model="usuarioasignado"
                        v-validate="'required'"
                        name="Código asignado"
                        v-if="showOnly"
                        disabled
                      ></b-form-input>
                      <b-form-input
                        autocomplete="off"
                        v-model="usuarioasignado"
                        @input="loadUser"
                        v-validate="'required'"
                        name="Código asignado"
                        v-else
                      ></b-form-input>
                      <div v-if="show_names" class="autocomplete-items">
                        <div
                          @click="setElement(element)"
                          v-for="(element, index) in names_suggestions"
                          v-bind:key="index"
                        >{{element.first_name}} {{element.last_name}} ({{element.username}})</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>
            <br>
            <b-card v-if = 'newLote.metodo_lote_selected.id === "Manual" ' class="text-center" style="border-color: #7b7b7b;">
              <h2>Lote Manual</h2>

              <b-row>
                <b-col lg="auto">
                  <b-button
                    :disabled="count_comerciales_in_geometry === '...' || showOnly"
                    @click="addEstablecimientos"
                  >Añadir establecimientos</b-button>
                </b-col>
                <b-col lg="auto">
                  <b-button :disabled='showOnly' @click="removeEstablecimientos">Quitar establecimientos</b-button>
                </b-col>

                <b-col lg="auto">
                  <b-button @click="showEstablecimientos" variant="outline-primary">
                    Establecimientos actuales
                    <b-badge variant="primary">{{ computedNumberManualEstablecimientos }}</b-badge>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
            <br>
            <b-card  v-if = 'newLote.metodo_lote_selected.id === "Parametrizado" '  class="text-center" style="border-color: #7b7b7b;">
              <h2>Filtro atributos</h2>
              <b-form>
                <b-form-row>
                  <b-col lg="4">
                    <b-form-group
                      v-if="newLote.tipo_lote_selected.id==='GC'"
                      id="categoriaestablecimiento"
                      label="Categoría Establecimiento:"
                      label-for="categoriaestablecimientoinput"
                    >
                      <multiselect
                        v-model="filtros.id_categoria_gn_comercial"
                        :options="optsfiltros.id_categoria_gn_comercial"
                        id="categoriaestablecimientoinput"
                        class="mb-3"
                        placeholder="Seleccionar"
                        label="categoria_gn_comercial"
                        multiple
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"
                        @input="setOptionsTipoEstablecimiento"
                      />
                    </b-form-group>
                    <b-form-group
                      v-else
                      id="categoriaestablecimiento"
                      label="Categoria Establecimiento:"
                      label-for="categoriaestablecimientoinput"
                    >
                      <multiselect
                        v-model="filtros.id_categoria_gn_caldera"
                        :options="parentoptsfiltroscaldera.id_categoria_gn_caldera"
                        id="categoriaestablecimientoinput"
                        class="mb-3"
                        placeholder="Seleccionar"
                        label="categoria_gn_caldera"
                        multiple
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col lg="4">
                    <b-form-group
                      id="tipoestablecimiento"
                      label="Tipo Establecimiento:"
                      v-if="newLote.tipo_lote_selected.id==='GC'"
                      label-for="tipoestablecimientoinput"
                    >
                      <multiselect
                        v-model="filtros.id_tipo_establecimiento_gn_comercial"
                        :options="optsfiltros.id_tipo_establecimiento_gn_comercial"
                        id="tipoestablecimientoinput"
                        class="mb-3"
                        placeholder="Seleccionar"
                        label="tipo"
                        name="Tipo establecimiento"
                        multiple
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"

                      />
                      <span class="error">{{ errors.first('Tipo establecimiento') }}</span>
                    </b-form-group>
                    <b-form-group
                      id="tipoestablecimiento"
                      label="Tipo Establecimiento:"
                      v-else
                      label-for="tipoestablecimientoinput"
                    >
                      <multiselect
                        v-model="filtros.id_tipo_establecimiento_gn_caldera"
                        :options="parentoptsfiltroscaldera.id_tipo_establecimiento_gn_caldera"
                        id="tipoestablecimientoinput"
                        class="mb-3"
                        placeholder="Seleccionar"
                        label="tipo"
                        name="Tipo establecimiento"
                        multiple
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"

                      />
                      <span class="error">{{ errors.first('Tipo establecimiento') }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group
                      v-if="newLote.tipo_lote_selected.id==='GC'"
                      id="claseestablecimiento"
                      label="Clase de establecimiento NEDGIA:"
                      label-for="claseestablecimientoinput"
                    >
                      <!-- <b-form-select
                          name="Categoria GN"
                          v-model="filtros.id_clase_establecimiento_gn_comercial"
                          :options="optsfiltros.id_clase_establecimiento_gn_comercial"
                          class="mb-3"
                          :text-field="'tipo'"
                          value-field="id"
                      :disabled="showOnly"/>-->

                      <multiselect
                        multiple
                        v-model="filtros.id_clase_establecimiento_gn_comercial"
                        :options="optsfiltros.id_clase_establecimiento_gn_comercial"
                        id="claseestablecimientoinput"
                        class="mb-3"
                        placeholder="Seleccionar"
                        label="tipo"
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"
                      />

                      <!-- <multiselect  v-model="filtros.id_clase_establecimiento_gn_comercial"
                                        :options="optsfiltros.id_clase_establecimiento_gn_comercial"
                                        id="claseestablecimientoinput"
                                        class="mb-3"
                                        placeholder="Todos"
                                        label="tipo"
                      track-by="id" :disabled="showOnly"/>-->
                    </b-form-group>
                    <b-form-group
                      v-else
                      id="claseestablecimiento"
                      label="Clase de establecimiento NEDGIA:"
                      label-for="claseestablecimientoinput"
                    >
                      <!-- <b-form-select
                          name="Categoria GN"
                          v-model="filtros.id_clase_establecimiento_gn_caldera"
                          :options="parentoptsfiltroscaldera.id_clase_establecimiento_gn_caldera"
                          class="mb-3"
                          :text-field="'tipo'"
                          value-field="id"
                      :disabled="showOnly"/>-->

                      <multiselect
                        v-model="filtros.id_clase_establecimiento_gn_caldera"
                        :options="parentoptsfiltroscaldera.id_clase_establecimiento_gn_caldera"
                        id="claseestablecimientoinput"
                        class="mb-3"
                        multiple
                        placeholder="Seleccionar"
                        label="tipo"
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col lg="4">
                    <b-form-group
                      id="statusgestion"
                      label="Status gestión:"
                      label-for="statusgestioninput"
                    >
                      <!-- <b-form-select
                      name="Categoria GN"
                      v-model="filtros.id_status_gestion"
                      :options="optsfiltros.id_status_gestion"
                      class="mb-3"
                      :text-field="'status'"
                      value-field="id"
                      :disabled="showOnly"/>-->
                      <multiselect
                        v-model="filtros.id_status_gestion"
                        :options="optsfiltros.id_status_gestion"
                        multiple
                        id="statusgestioninput"
                        class="mb-3"
                        placeholder="Seleccionar"
                        label="status"
                        track-by="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group id="distancia" label="Distancia:" label-for="distanciainput">
                      <b-form-select
                        name="Categoria GN"
                        v-model="filtros.in_service_mains_distance"
                        :options="optsfiltros.in_service_mains_distance"
                        class="mb-3"
                        style="height:43px;"
                        :text-field="'label'"
                        value-field="id"
                        :disabled="showOnly || newLote.metodo_lote_selected.id === 'Manual'"
                      />
                      <!-- <multiselect v-model="filtros.in_service_mains_distance"
                                    :options="optsfiltros.in_service_mains_distance"
                                    id="distanciainput"
                                    class="mb-3"
                                    placeholder="Todos"
                                    label="label"
                      track-by="id" :disabled="showOnly"/>-->
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </b-form>

              <div>
                <span>Total {{textCount}}: {{count_comerciales}}</span>
              </div>
              <b-button
                @click="getNumberOfComerces"
                v-if="!showOnly"
                :disabled="loadingtipos || newLote.metodo_lote_selected.id === 'Manual' "
              >
                <span v-if="loadingtipos">
                  <i class="fa fa-spinner fa-spin fa-3x"></i>
                </span>
                <span v-else>Aplicar</span>
              </b-button>
            </b-card>
            <br>
            <b-card v-if = 'newLote.metodo_lote_selected.id === "Parametrizado" '   class="text-center" style="border-color: #7b7b7b;">
              <h2>Filtro área geográfica</h2>
              <b-form>
                <b-row>
                  <b-col lg="2">
                    <b-form-group label="Número de geometrías">
                      <b-form-input
                        v-validate="'required'"
                        name="Numero de geometrias"
                        v-model="geometrias.numero_geometrias"
                        disabled
                      ></b-form-input>
                      <span class="error">{{ errors.first('Numero de geometrias') }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col lg="2">
                    <b-form-group :label="'Número de '+textCount">
                      <!-- <b-form-input v-validate="'required'" name="Numero de comerciales" v-model="geometrias.numero_comerciales" disabled></b-form-input> -->
                      <b-form-input
                        v-validate="'required'"
                        name="Numero de comerciales"
                        v-model="count_comerciales_in_geometry"
                        disabled
                      ></b-form-input>
                      <span class="error">{{ errors.first('Número de comerciales') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>

              <b-button
                @click="drawPolygon"
                :disabled="newLote.metodo_lote_selected.id === 'Manual'"
                v-if="!showOnly"
              >Filtro área</b-button>
              <b-button @click="drawPolygonView" v-else>Ver áreas</b-button>
            </b-card>
            <b-row class="mt-3">
              <b-col>
                <b-button @click="cancelSaveLote">Cancelar</b-button>
                <b-button @click="validateLote" v-if="!showOnly">Guardar</b-button>
                <b-button @click="showModalResumen">Resumen</b-button>
                <b-button @click="showModalList">Lista</b-button>
                <b-button @click="exportarLote">Exportar</b-button>
                <b-button v-if='!showOnly' @click="checkSolapes">Solapes</b-button>
              </b-col>
            </b-row>
          </template>
        </div>
      </b-modal>
      <b-modal
        id="modalPreventDeleteid"
        ref="modalPreventDelete"
        @ok="deleteLote()"
        @hidden="hideModalPrevent"
      >¿Desea eliminar el lote?</b-modal>
      <b-modal id="modalResumeLoteid" ok-only ref="modalResumeLote" @hidden="hiddenModalResumen">
        <b-list-group class="scroll">
          <b-list-group-item>
            <b-row>
              <b-col>Categoría</b-col>
              <b-col>Visitas</b-col>
              <b-col>Sin Visitas</b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item v-for="(total, cat) in cerrarlote_resumen" :key="'cerrarlote_' + cat">
            <b-row>
              <b-col>{{cat}}</b-col>
              <b-col>{{total.visitas}}</b-col>
              <b-col>{{total.novisitas}}</b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-modal>
      <b-modal
        id="modalCerrarLoteid"
        ref="modalCerrarLote"
        @ok="confirmModal = true"
        @hidden="hideCerrarLote"
      >
        <b-list-group class="scroll">
          <b-list-group-item>
            <b-row>
              <b-col>Categoría</b-col>
              <b-col>Visitas</b-col>
              <b-col>Sin Visitas</b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item v-for="(total, cat) in cerrarlote_resumen" :key="'cerrarlote_' + cat">
            <b-row>
              <b-col>{{cat}}</b-col>
              <b-col>{{total.visitas}}</b-col>
              <b-col>{{total.novisitas}}</b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-modal>
      <b-modal
        id="modalPreventCerrarLoteId"
        ref="modalPreventCerrarLote"
        @ok="cerrarLoteConfirm"
        @hidden="hideModalPreventCerrar"
      >¿Desea cerrar el lote?</b-modal>
    </div>
    <b-row>
      <b-col lg="8">
        <b-alert :show="gestionandoLote" variant="primary">
          Gestionando lote: {{loteGestion}} ({{loteGestionando.tipo_lote}})
          <br>
          <b-btn class="mt-2" @click="showList">LISTA</b-btn>
          <b-btn class="mt-2" @click="exitGestion" style="float:right;">Finalizar</b-btn>
        </b-alert>
      </b-col>
    </b-row>
    <LotesList
      v-if="listFlag"
      :user="user"
      :id="loteGestion"
      :tipo_lote="loteGestionando.tipo_lote"
      :permisos="permisos"
      @hidden="listFlag=false"
    ></LotesList>
  </div>
</template>

<style lang="scss">
tr.tr-lotes-table {
  td {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
    vertical-align: middle;
  }
}

.form-group#categoriaestablecimiento .multiselect__tags, .form-group#tipoestablecimiento .multiselect__tags {
  position: relative !important;
}
</style>

<style>
.lotes-popup {
  position: absolute;
  top: 60px;
  right: 60px;
  width: calc(100% - 400px);
  z-index: 9;
}
.hideFilter .VueTables__filters-row {
  display: none;
}

.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  /* display: inline-block; */
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}
.autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}
.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}

.buttons-draw {
  position: absolute;
  bottom: 0;
}
</style>

<script>
var debounce = require('debounce');
import Loader from '@/components/Layout/Loader.vue';
import Table from '@/components/Modules/Table/Table.vue';
import Actions from './LotesTableActions.vue';
import checkBox from '@/components/Modules/Misc/checkBox.vue';
import moment from 'moment';
import LotesList from '@/components/Modules/LotesList.vue';
import LotesList2 from '@/components/Modules/LotesList2.vue';
import LotesListSolapados from '@/components/Modules/LotesListSolapados.vue';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'LotePopUp',
  props: ['permisos', 'user', 'parentoptsfiltros', 'parentoptsfiltroscaldera'],
  components: { Loader, Table, Actions, checkBox, LotesList, LotesList2, LotesListSolapados },
  data () {
    return {
      clickedGetCountButton: false,
      lotesList: {
        idis: [], // ['3822034', '3838706'],
        show: false
      },
      lotesListSolapados: {
        idis: [], // ['3822034', '3838706'],
        show: false
      },
      idsResumen: [],
      addEstablecimientoModal: {
        textarea: '',
        error: null
      },
      removeEstablecimientoModal: {
        textarea: '',
        error: null
      },
      loadFinished: false,
      listFlag: false,
      editID: null,
      edit: false,
      loading: false,
      hideModalflag: false,
      loading_table: true,
      toMe: true,
      forMe: true,
      loteForm: false,
      drawing: false,
      otherActionsLote: false,
      loteGestion: '',
      gestionandoLote: false,
      loteGestionando: { tipo_lote: '' },
      showOnly: false,
      loadingtipos: false,
      columns: [
        { text: 'id', filterable: false },
        { text: 'tipo_lote', filterable: false },
        { text: 'metodo_lote', filterable: false },
        { text: 'descripcion', filterable: false },
        { text: 'usuario_asignador', filterable: true },
        { text: 'usuario_asignado', filterable: true },
        { text: 'status', filterable: false },
        { text: 'create_date', filterable: false },
        { text: 'fecha_inicio_prevista', filterable: false },
        { text: 'fecha_cierre_prevista', filterable: false },
        { text: 'fecha_inicio_real', filterable: false },
        { text: 'fecha_cierre_real', filterable: false }
      ],
      options: {
        actions: Actions,
        rowClassCallback: () => {
          return 'tr-lotes-table';
        },
        filterByColumn: true,
        filterable: false,
        perPage: 10,
        perPageValues: [],
        initFilters: {
          usuario_asignador: '',
          usuario_asignado: ''
        },
        headings: {
          actions: 'Acciones',
          id: 'Código lote',
          tipo__lote: 'Tipo',
          descripcion: 'Descripción',
          create_date: 'Fecha creación'
        }
      },
      filtros: {
        id_categoria_gn_comercial: [],
        id_clase_establecimiento_gn_comercial: [],
        id_clase_establecimiento_gn_caldera: [],
        id_status_gestion: [],
        id_categoria_gn_caldera: [],
        in_service_mains_distance: null,
        id_tipo_establecimiento_gn_caldera: [],
        id_tipo_establecimiento_gn_comercial: []
      },
      modalTitle: 'Lotes',
      newLote: {
        tipo_lote: 'GC',
        tipo_lote_selected: { id: 'GC', label: 'Gran Consumo' },
        metodo_lote_selected: { id: 'Parametrizado', label: 'Parametrizado' },
        status: 'Creado',
        descripcion: '',
        usuario_asignador: '',
        fecha_inicio_prevista: '',
        fecha_cierre_prevista: '',
        usuario_asignado: '',
        create_user: '',
        filtro_alfanumerico: '',
        filtro_manual: [],
        geom_geojson: [],
        geom: ''
      },
      nombre_asignador: '',
      tipos_lotes: [
        { id: 'GC', label: 'Gran Consumo' },
        { id: 'CC', label: 'Caldera Centralizada' }
      ],
      metodos_lotes: [
        { id: 'Parametrizado', label: 'Parametrizado' },
        { id: 'Manual', label: 'Manual' }
      ],
      geometrias: {
        numero_geometrias: 0,
        numero_comerciales: null
      },
      count_comerciales: 0,
      count_comerciales_in_geometry: null,
      usuarioasignado: '',
      clickHappened: false,
      show_names: false,
      names_suggestions: [],
      categorias_en_poligono: {},
      cerrarlote_resumen: {},
      cerrandoLote: false,
      loteCerrado: '',
      optsfiltros: {},
      confirmModal: false
    };
  },
  computed: {
    computedNumberManualEstablecimientos: function () {
      return this.newLote.filtro_manual.length;
    },

    textCount: function () {
      if (this.newLote.tipo_lote_selected.id === 'GC') {
        return 'establecimientos';
      } else {
        return 'calderas';
      }
    }
  },
  mounted: function () {
    this.$refs.modalLotes.show();
    this.updateTable();
    this.newLote.usuario_asignador = this.user;

    this.$http
      .get('users/', { params: { username: this.newLote.usuario_asignador } })
      .then(result => {
        this.nombre_asignador =
          result.data[0].first_name + ' ' + result.data[0].last_name;
      });

    this.newLote.create_user = this.user;
    this.optsfiltros = Object.assign({}, this.parentoptsfiltros);
    this.optsfiltros.id_tipo_establecimiento_gn_comercial = [];
  },
  methods: {

    checkSolapes: function () {
      if (this.newLote.metodo_lote_selected.id === 'Parametrizado' && this.count_comerciales_in_geometry > 1000) {
        alert('El lote tiene muchos comerciales/calderas. Por favor, acota más los filtros.');
      } else {
        if (this.newLote.metodo_lote_selected.id === 'Parametrizado') {
          this.lotesListSolapados.idis = this.idsResumen;
        } else {
          this.lotesListSolapados.idis = this.newLote.filtro_manual;
        }

        this.$http.post('asignacion_lote_solapados/checksolapes/', {
          lote_id: this.newLote.id,
          tipo_lote: this.newLote.tipo_lote_selected.id,
          idis: this.lotesListSolapados.idis.map(x => { return parseInt(x); })
        }).then(result => {
          if (result.body.check === true) {
            alert('No hay solapes');
          } else {
            this.lotesListSolapados.show = true;
          }
        });
      }
    },

    exportarLote: function () {
      // this.$http.get('asignacion_lote/', {params: {id_lote: this.newLote.id, not_paginated: true}}).then(result => {
      let type = (this.newLote.tipo_lote_selected.id === 'GC') ? 'comercial' : 'caldera';
      // var list = result.data.map(e => e['id_' + type])
      let list = [];

      if (this.newLote.metodo_lote === 'Parametrizado' && this.count_comerciales_in_geometry > 1000) {
        alert('El lote tiene muchos comerciales/calderas. Por favor, acota más los filtros.');
      } else {
        if (this.newLote.metodo_lote_selected.id === 'Manual') {
          list = this.newLote.filtro_manual;
        } else {
          list = this.idsResumen;
        }

        list = list.join(',');

        var q = '';
        if (type === 'comercial') {
          q = 'c.id_comercial';
        } else {
          q = 'cent.id_caldera';
        }
        q = q + ' IN (' + list + ')';
        var path = {name: 'Download'};
        if (Object.keys(q).length) {
          path['query'] = {'q': q, 'type': type, 'lote': this.newLote.id};
          if (this.limitedPermision()) {
            path['query']['user'] = true;
          }
        }
        let routeData = this.$router.resolve(path);
        window.open(routeData.href, '_blank');
      }

      // })
    },

    deleteFromLote: function (idis) {
      if (this.removeEstablecimiento(idis)) {
        this.lotesList.idis = this.newLote.filtro_manual;
        this.lotesListSolapados.idis = this.newLote.filtro_manual;

        // this.$refs.loteslist2.options.initFilters = {idis: this.$refs.loteslist2.idis.join(','), id_lote: this.$refs.loteslist2.id_lote, tipo_lote: this.$refs.loteslist2.tipo_lote}
        // this.$refs.loteslist2.$refs.table.refresh()
      }
    },

    deleteFromParametrizadoLote: function (idis) {
      if (confirm('El lote pasará a ser manual y se perderán los filtros por atributos y por área. ¿Desea eliminar este establecimiento del lote?')) {
        if (this.count_comerciales_in_geometry > 1000) {
          alert(
            'El lote tiene muchos comerciales/calderas. Por favor, acota más los filtros.'
          );
        } else {
          this.newLote.filtro_alfanumerico = '';
          this.newLote.geom_geojson = [];
          this.newLote.metodo_lote_selected = {
            id: 'Manual',
            label: 'Manual'
          };

          this.newLote.metodo_lote = this.newLote.metodo_lote_selected.id;
          this.newLote.filtro_manual = this.idsResumen;

          this.count_comerciales_in_geometry = 'N/A';
          this.count_comerciales = 'N/A';

          if (this.removeEstablecimiento(idis)) {
            this.lotesList.idis = this.newLote.filtro_manual;
            this.lotesListSolapados.idis = this.newLote.filtro_manual;
            this.idsResumen = this.newLote.filtro_manual;
          }

          // this.$refs.addEstablecimientoModal.show()
        }
      }
    },

    addEstablecimientoModalOkSync: function (bvModalEvt) {
      bvModalEvt.preventDefault();
      this.addEstablecimientoModalOk().then(x => {
        if (x === true) {
          this.$nextTick(() => {
            this.$refs.addEstablecimientoModal.hide();
          });
          // No errors
          // this.newLote.filtro_alfanumerico = ''
          // this.newLote.geom_geojson = []
          // this.newLote.metodo_lote_selected = {id: 'Manual', label: 'Manual'}

          // this.newLote.filtro_manual = this.idsResumen
        } else {
          // Errors
        }
      });
    },

    addEstablecimientoModalOk: async function () {
      let prevList = this.newLote.filtro_manual;
      let newIDIs = this.addEstablecimientoModal.textarea;

      let newList = newIDIs.match(/([0-9A-Za-z]+)/g);

      if (newList === null) {
        newList = [];
      }

      var type = 'comercial2';
      if (this.newLote.tipo_lote_selected.id === 'CC') {
        type = 'caldera3';
      }

      let promisesMap = newList.map(x => {
        return this.$http.get(type + '/' + x);
      });

      let results = await Promise.all(promisesMap.map(p => p.catch(e => e)));

      let validResults = results.filter(result => result.status === 200);

      let idisValid = validResults.map(x => {
        return x.url.split('/').slice(-1)[0];
      });

      let idisInvalid = newList.filter(el => !idisValid.includes(el));

      if (idisInvalid.length > 0) {
        this.addEstablecimientoModal.error =
          'Los siguientes IDIs introducidos no existen: ' +
          idisInvalid.join(', ');
        return false;
      }

      let idisAlready = newList.filter(el => prevList.includes(el));

      if (idisAlready.length > 0) {
        this.addEstablecimientoModal.error =
          'Los siguientes IDIs introducidos ya se encuentran en el lote: ' +
          idisAlready.join(', ');
        return false;
      }

      newList = newList.map(x => {
        return x.toString();
      });

      this.newLote.filtro_manual = [...this.newLote.filtro_manual, ...newList];

      this.addEstablecimientoModal.textarea = '';

      return true;

      /* else {
        alert('Todos los IDIs introducidos son correctos')
      } */

      /* .then(x => {
        console.log('A')
      }).catch(function (err) {
        if (err.status === 404) {
          alert('Almenos uno de los IDIs introducidos no existe: ' + err.url.split('/').slice(-1)[0])
        }
        console.log('B')
      }) */

      // debugger
    },

    removeEstablecimiento: function (removeIDIs) {
      let prevList = this.newLote.filtro_manual;

      let removeList = removeIDIs.match(/([0-9]+)/g);

      let idisNotAlready = removeList.filter(el => !prevList.includes(el));

      if (idisNotAlready.length > 0) {
        this.removeEstablecimientoModal.error =
          'Los siguientes IDIs introducidos no se encuentran en el lote: ' +
          idisNotAlready.join(', ');
        return false;
      }

      this.newLote.filtro_manual = this.newLote.filtro_manual.filter(
        el => !removeList.includes(el)
      );

      return true;
    },

    removeEstablecimientoModalOk: function (bvModalEvt) {
      let removeIDIs = this.removeEstablecimientoModal.textarea;

      if (this.removeEstablecimiento(removeIDIs)) {
        this.removeEstablecimientoModal.textarea = '';
      } else {
        bvModalEvt.preventDefault();
      }
    },

    changedMetodoLote: function (val) {
      if (this.newLote.metodo_lote_selected.id === 'Manual') {
        if (this.count_comerciales_in_geometry > 0) {
          if (confirm(
            'El lote pasará a ser manual y se perderán los filtros por atributos y por área. ¿Deseas continuar?'
          )
          ) {
            if (this.count_comerciales_in_geometry > 1000) {
              alert(
                'El lote tiene muchos comerciales/calderas. Por favor, acota más los filtros.'
              );
              this.newLote.metodo_lote_selected = {
                id: 'Parametrizado',
                label: 'Parametrizado'
              };
            } else {
              this.newLote.filtro_alfanumerico = '';
              this.newLote.geom_geojson = [];
              this.newLote.metodo_lote_selected = {
                id: 'Manual',
                label: 'Manual'
              };
              this.newLote.filtro_manual = this.idsResumen;

              this.count_comerciales_in_geometry = 'N/A';
              this.count_comerciales = 'N/A';

            // this.$refs.addEstablecimientoModal.show()
            }
          } else {
            this.newLote.metodo_lote_selected = {
              id: 'Parametrizado',
              label: 'Parametrizado'
            };
          }
        } else {
          if (this.clickedGetCountButton) {
            if (confirm(
              'El lote pasará a ser manual y se perderán los filtros por atributos y por área. ¿Deseas continuar?'
            )
            ) {
              this.newLote.filtro_alfanumerico = '';
              this.newLote.geom_geojson = [];
              this.newLote.metodo_lote_selected = {
                id: 'Manual',
                label: 'Manual'
              };
              this.newLote.filtro_manual = this.idsResumen;

              this.count_comerciales_in_geometry = 'N/A';
              this.count_comerciales = 'N/A';
            } else {
              this.newLote.metodo_lote_selected = {
                id: 'Parametrizado',
                label: 'Parametrizado'
              };
            }
          } else {
            this.newLote.filtro_alfanumerico = '';
            this.newLote.geom_geojson = [];
            this.newLote.metodo_lote_selected = {
              id: 'Manual',
              label: 'Manual'
            };
            this.newLote.filtro_manual = this.idsResumen;

            this.count_comerciales_in_geometry = 'N/A';
            this.count_comerciales = 'N/A';
          }
        }
      }
    },

    addEstablecimientos: function () {
      /* if (this.newLote.metodo_lote_selected.id === 'Parametrizado') {
        if (
          confirm(
            'El lote pasará a ser manual y se perderán los filtros por atributos y por área. ¿Deseas continuar?'
          )
        ) {
          if (this.count_comerciales_in_geometry > 1000) {
            alert('El lote tiene muchos comerciales/calderas. Por favor, acota más los filtros.')
          } else {
            this.newLote.filtro_alfanumerico = ''
            this.newLote.geom_geojson = []
            this.newLote.metodo_lote_selected = {
              id: 'Manual',
              label: 'Manual'
            }
            this.newLote.filtro_manual = this.idsResumen

            this.count_comerciales_in_geometry = 'N/A'
            this.count_comerciales = 'N/A'

            this.$refs.addEstablecimientoModal.show()
          }
        }
      } else { */
      this.$refs.addEstablecimientoModal.show();
      // }
    },

    showEstablecimientos: function () {
      this.$refs.showEstablecimientoModal.show();
    },

    removeEstablecimientos: function () {
      this.$refs.removeEstablecimientoModal.show();
    },

    changedFechaCierre: function (val) {
      let fechaCierre = this.$moment(val, 'YYYY-MM-DD');
      let fechaInicio = this.$moment(
        this.newLote.fecha_inicio_prevista,
        'YYYY-MM-DD'
      );

      if (fechaCierre.isBefore(fechaInicio)) {
        alert(
          'La fecha de cierre introducida (' +
            fechaCierre.format('DD-MM-YYYY') +
            ') no puede ser anterior a la fecha de inicio (' +
            fechaInicio.format('DD-MM-YYYY') +
            ')'
        );
        this.newLote.fecha_cierre_prevista = '';
      }
    },
    changedFechaInicio: function (val) {
      let fechaCierre = this.$moment(
        this.newLote.fecha_cierre_prevista,
        'YYYY-MM-DD'
      );
      let fechaInicio = this.$moment(val, 'YYYY-MM-DD');

      if (fechaCierre.isBefore(fechaInicio)) {
        alert(
          'La fecha de inicio introducida (' +
            fechaInicio.format('DD-MM-YYYY') +
            ') no puede ser posterior a la fecha de cierre (' +
            fechaCierre.format('DD-MM-YYYY') +
            ')'
        );
        this.newLote.fecha_inicio_prevista = '';
      }
    },

    removedPolygon: function (index) {
      this.newLote.geom_geojson.splice(index, 1);
    },
    showList: function () {
      this.listFlag = true;
    },
    getCount: function () {
      this.clickedGetCountButton = true;
      this.count_comerciales = '...';
      this.count_comerciales_in_geometry = '...';

      var type = { type: 'comercial' };
      if (this.newLote.tipo_lote_selected.id === 'CC') {
        type = { type: 'caldera' };
      }

      var params = { ...type, ...this.getFilters(type.type) };

      if (type.type === 'comercial') {
        // Comercial

        // if (
        //   this.filtros.id_clase_establecimiento_gn_comercial.length > 0
        // ) {
        //   params.id_clase_establecimiento_gn_comercial__in = this.filtros.id_clase_establecimiento_gn_comercial.map(
        //     e => e.id
        //   )
        // } else {
        //   params.id_clase_establecimiento_gn_comercial__in = []
        // }

        if (this.filtros.id_status_gestion.length > 0) {
          params.id_status_gestion_comercial__in = this.filtros.id_status_gestion.map(
            e => e.id
          );
          if (params.id_status_gestion_comercial__in[0] === null) {
            delete params['id_status_gestion_comercial__in'];
          }
        } else {
          // params.id_status_gestion_comercial__in = []
        }
      } else {
        // Caldera

        // if (
        //   this.filtros.id_clase_establecimiento_gn_caldera.length > 0
        // ) {
        //   params.id_clase_establecimiento_gn_caldera__in = this.filtros.id_clase_establecimiento_gn_caldera.map(
        //     e => e.id
        //   )
        // } else {
        //   params.id_clase_establecimiento_gn_caldera__in = []
        // }

        if (this.filtros.id_status_gestion.length > 0) {
          params.id_status_gestion_caldera__in = this.filtros.id_status_gestion.map(
            e => e.id);
          if (params.id_status_gestion_caldera__in[0] === null) {
            delete params['id_status_gestion_caldera__in'];
          }
        } else {
          // params.id_status_gestion_caldera__in = []
        }
      }

      this.$http.post('count/', { params: params }).then(result => {
        this.count_comerciales = result.data.count;
      });

      var tmp = [];
      tmp = this.getLayersJSON();

      if (tmp.length > 0) {
        params.geom__dwithin = tmp;
      }

      this.geometrias.numero_geometrias = tmp.length;

      this.$http.post('count/', { params: params }).then(result => {
        this.count_comerciales_in_geometry = result.data.count;
        this.idsResumen = result.data.ids_resumen.map(x => { return x.toString(); });

        if (this.newLote.tipo_lote_selected.id === 'CC') {
          this.categorias_en_poligono = this.parentoptsfiltroscaldera.id_categoria_gn_caldera.map(
            e => {
              return {
                cat: e.categoria_gn_caldera,
                total: 0,
                id_categoria_gn_caldera: e.id
              };
            }
          );
        } else if (this.newLote.tipo_lote_selected.id === 'GC') {
          this.categorias_en_poligono = this.parentoptsfiltros.id_categoria_gn_comercial.map(
            e => {
              return {
                cat: e.categoria_gn_comercial,
                total: 0,
                id_categoria_gn_comercial: e.id
              };
            }
          );
        }
        this.categorias_en_poligono = this.categorias_en_poligono.map(e => {
          for (let index = 0; index < result.data.dictresumen.length; index++) {
            const element = result.data.dictresumen[index];
            if (
              element.id_categoria_gn_comercial === e.id_categoria_gn_comercial
            ) {
              return element;
            }
          }
          return e;
        });
        // Object.assign(this.categorias_en_poligono, result.data.dictresumen)
      });
    },
    limitedPermision () {
      if (this.$parent.hasPermision({ rol: 'GESTION COMERCIAL' }, 'A')) {
        return true;
      }
      return false;
    },
    initAddLote () {
      this.clearFilters();
      this.loteForm = true;
      this.edit = false;
      this.showOnly = false;
      // this.getCount()
      this.loadFinished = true;
    },
    setOptionsTipoEstablecimiento () {
      if (this.filtros.id_categoria_gn_comercial.length) {
        this.loadingtipos = true;
        var params = {
          params: {
            not_paginated: true,
            id_categoria_gn_comercial__in: this.filtros.id_categoria_gn_comercial.map(
              v => v.id
            )
          }
        };
        this.$http.get('tipos_comercial/', params).then(result => {
          var todas = [];
          for (let i in this.filtros.id_categoria_gn_comercial) {
            var cat = this.filtros.id_categoria_gn_comercial[i];

            todas.push({
              id: 'Todas ' + cat.id,
              tipo: 'Todas ' + cat.categoria_gn_comercial
            });
          }
          this.optsfiltros.id_tipo_establecimiento_gn_comercial = todas.concat(
            result.data
          );
          if (!this.filtros.id_tipo_establecimiento_gn_comercial.length) {
            this.filtros.id_tipo_establecimiento_gn_comercial = [
              this.optsfiltros.id_tipo_establecimiento_gn_comercial[0]
            ];
          }
          this.loadingtipos = false;
          this._removeOptsFromRequest();
        });
      } else {
        this.filtros.id_tipo_establecimiento_gn_comercial = [];
        this.optsfiltros.id_tipo_establecimiento_gn_comercial = [];
      }
    },
    _removeOptsFromRequest () {
      this.filtros.id_tipo_establecimiento_gn_comercial = this.filtros.id_tipo_establecimiento_gn_comercial.filter(
        v =>
          this.optsfiltros.id_tipo_establecimiento_gn_comercial.find(
            i => i.id === v.id
          )
      );
    },
    getTiposEstablecimientos (filter) {
      this.optsfiltros.id_tipo_establecimiento_gn_comercial = [];
      for (let index = 0; index < filter.length; index++) {
        const element = filter[index];
        this.optsfiltros.id_tipo_establecimiento_gn_comercial.push({
          id: element,
          tipo: element
        });
      }
      var params = {
        params: { not_paginated: true, id_categoria_gn_comercial__in: filter }
      };
      this.$http.get('tipos_comercial/', params).then(result => {
        this.optsfiltros.id_tipo_establecimiento_gn_comercial = this.optsfiltros.id_tipo_establecimiento_gn_comercial.concat(
          result.body
        );
      });
    },
    setElement (element) {
      this.newLote.usuario_asignado = element.username;
      this.usuarioasignado = element.first_name + ' ' + element.last_name;
      this.show_names = false;
      this.clickHappened = true;

      var th = this;
      setTimeout(() => {
        th.clickHappened = false;
      }, 400);
    },
    updateTable: function () {
      this.loading_table = true;
      if (this.toMe) {
        this.options.initFilters.usuario_asignado = this.user;
      } else {
        this.options.initFilters.usuario_asignado = '';
      }
      if (this.forMe) {
        this.options.initFilters.usuario_asignador = this.user;
      } else {
        this.options.initFilters.usuario_asignador = '';
      }

      var th = this;
      setTimeout(function () {
        th.loading_table = false;
      }, 300);
    },
    hasPermision: function (group, p) {
      if (group === 'caldera') {
        return this.$parent.permisos['CALDERA CENTRALIZADA'][p];
      } else if (group === 'comercial') {
        return this.$parent.permisos['COMERCIAL'][p];
      } else {
        if (group.name === 'Territorio') {
          return (
            this.$parent.permisos['TERRITORIO GN'][p] ||
            this.$parent.permisos['TERRITORIO NO GN'][p]
          );
        } else {
          if (group.rol) {
            return this.$parent.permisos[group.rol][p];
          } else {
            return false;
          }
        }
      }
    },
    showModal (cancel = false) {
      this.loteForm = true;
      this.hideModalflag = false;
      // this.getCount()
      var th = this;
      setTimeout(() => {
        th.$refs.modalLotes.show();
        th.drawing = false;
        th.setDrawTool(false);
        th.$parent.$parent.map.drawer.disable();
        if (cancel) {
          th.removeLayers();
          th.$parent.$parent.setDrawerLayersFromLote(
            th.newLote.geom_geojson,
            false
          );
        }
      }, 100);
    },
    setDrawTool (value) {
      this.$parent.setDraw(value);
    },
    deleteLote () {
      this.$http
        .post('comercial/' + this.deletelote + '/deletelote/')
        .then(response => {
          this.$refs.table.refresh();
          this.deletelote = null;
        });
    },
    preventDelete (id) {
      this.deletelote = id;
      this.otherActionsLote = true;
      this.$refs.modalLotes.hide();
      this.$refs.modalPreventDelete.show();
    },
    hideModalPrevent () {
      this.otherActionsLote = false;
      this.$refs.modalLotes.show();
    },
    showModalList () {
      if (this.newLote.metodo_lote === 'Parametrizado' && this.count_comerciales_in_geometry > 1000) {
        alert('El lote tiene muchos comerciales/calderas. Por favor, acota más los filtros.');
      } else {
        if (this.newLote.metodo_lote === 'Parametrizado') {
          this.lotesList.idis = this.idsResumen;
        } else {
          this.lotesList.idis = this.newLote.filtro_manual;
        }
        this.lotesList.show = true;
      }

      // this.$refs.modalLotes.hide()

      // this.this.newLote.filtro_manual
    },
    showModalResumen () {
      if (this.newLote.id) {
        // Editing

        if (this.newLote.metodo_lote_selected.id === 'Manual') {
          this.$http
            .post(
              'lotes/' + this.newLote.id + '/resumencategoriavisitasmanual/',
              {
                idis: this.newLote.filtro_manual
              }
            )
            .then(response => {
              this.cerrarlote_resumen = response.body.categorias;
              this.otherActionsLote = true;
              this.$refs.modalLotes.hide();
              this.$refs.modalResumeLote.show();
            });
        } else {
          this.$http
            .get('lotes/' + this.newLote.id + '/resumencategoriavisitas/')
            .then(response => {
              this.cerrarlote_resumen = response.body.categorias;
              this.otherActionsLote = true;
              this.$refs.modalLotes.hide();
              this.$refs.modalResumeLote.show();
            });
        }
      } else {
        // New lote

        if (this.newLote.metodo_lote_selected.id === 'Manual') {
          let type = 'comercial';
          if (this.newLote.tipo_lote_selected.id === 'CC') {
            type = 'caldera';
          }

          this.$http
            .post(type + '/resumencategoriavisitasmanual/', {
              idis: this.newLote.filtro_manual
            })
            .then(response => {
              this.cerrarlote_resumen = response.body.categorias;
              this.otherActionsLote = true;
              this.$refs.modalLotes.hide();
              this.$refs.modalResumeLote.show();
            });
        } else {
          let type = 'comercial';
          if (this.newLote.tipo_lote_selected.id === 'CC') {
            type = 'caldera';
          }

          let filtros = this.getFilters(type);
          if (Object.keys(filtros).length) {
            this.newLote.filtro_alfanumerico = JSON.stringify(filtros);
          }

          let copyLote = Object.assign({}, this.newLote);

          copyLote.fecha_inicio_prevista = moment().format('YYYY-MM-DDThh:mm');
          copyLote.fecha_cierre_prevista = moment().format('YYYY-MM-DDThh:mm');
          copyLote.tipo_lote = copyLote.tipo_lote_selected.id;

          if (!copyLote.filtro_alfanumerico) {
            copyLote.filtro_alfanumerico = '{}';
          }

          this.$http
            .post(type + '/resumencategoriavisitas/', copyLote)
            .then(response => {
              this.cerrarlote_resumen = response.body.categorias;
              this.otherActionsLote = true;
              this.$refs.modalLotes.hide();
              this.$refs.modalResumeLote.show();
            });
        }
      }
    },
    hiddenModalResumen () {
      this.otherActionsLote = false;
      this.$refs.modalResumeLote.hide();
      this.$refs.modalLotes.show();
    },
    cancelSaveLote () {
      this.clearFilters();
      this.loteForm = false;
      this.removeLayers();
    },
    onHidden () {
      if (
        !this.drawing &&
        !this.otherActionsLote &&
        !this.gestionandoLote &&
        !this.cerrandoLote
      ) {
        this.$parent.showLotes = false;
        this.loteForm = false;
        this.removeLayers();
      }
    },
    drawPolygon () {
      this.setDrawTool(true);
      this.$parent.$parent.drawAreaLotes = true;
      this.$parent.$parent.drawAreaLotesView = false;
      this.$refs.modalLotes.hide();
      this.hideModalflag = true;
      this.drawing = false;
      // this.addPolygon()
    },
    drawPolygonView () {
      this.setDrawTool(true);
      this.$refs.modalLotes.hide();
      this.hideModalflag = true;
      this.$parent.$parent.drawAreaLotes = true;
      this.$parent.$parent.drawAreaLotesView = true;
    },
    addPolygon () {
      this.$parent.$parent.map.drawer.enable();
    },
    removeLayers () {
      for (let i in this.$parent.$parent.map.drawerLayers) {
        let layer = this.$parent.$parent.map.drawerLayers[i];
        this.$parent.$parent.map.map.removeLayer(layer);
        delete this.$parent.$parent.map.drawerLayers[i];
      }
      this.$parent.$parent.map.drawerLayers = [];
    },
    getNumberOfComerces () {
      this.getCount();
    },
    getFilters (type) {
      var copy = {};
      try {
        if (this.filtros.id_categoria_gn_comercial.length) {
          copy.id_categoria_gn_comercial__in = this.filtros.id_categoria_gn_comercial.map(
            v => v.id
          );
        } else {
          // copy.id_categoria_gn_comercial__in = []
        }

        if (this.filtros.id_categoria_gn_caldera.length) {
          copy.id_categoria_gn_caldera__in = this.filtros.id_categoria_gn_caldera.map(
            v => v.id
          );
        } else {
          // copy.id_categoria_gn_caldera__in = []
        }

        if (this.filtros.id_tipo_establecimiento_gn_comercial.length) {
          copy.id_tipo_establecimiento_gn_comercial__in = this.filtros.id_tipo_establecimiento_gn_comercial.map(
            v => v.id
          );
        } else {
          // copy.id_tipo_establecimiento_gn_comercial__in = []
        }

        if (this.filtros.id_tipo_establecimiento_gn_caldera.length) {
          copy.id_tipo_establecimiento_gn_caldera__in = this.filtros.id_tipo_establecimiento_gn_caldera.map(
            v => v.id
          );
        } else {
          // copy.id_tipo_establecimiento_gn_caldera__in = []
        }

        /* Clase establecimiento */
        if (this.filtros.id_clase_establecimiento_gn_comercial.length) {
          copy.id_clase_establecimiento_gn_comercial__in = this.filtros.id_clase_establecimiento_gn_comercial.map(
            v => v.id
          );
        } else {
          // copy.id_clase_establecimiento_gn_comercial__in = []
        }

        if (this.filtros.id_clase_establecimiento_gn_caldera.length) {
          copy.id_clase_establecimiento_gn_caldera__in = this.filtros.id_clase_establecimiento_gn_caldera.map(
            v => v.id
          );
        } else {
          // copy.id_clase_establecimiento_gn_caldera__in = []
        }

        /* Status gestion */
        if (this.filtros.id_status_gestion.length) {
          if (this.filtros.id_status_gestion.length === 1 && this.filtros.id_status_gestion[0].id === null) {

          } else {
            copy['id_status_gestion__in'] = this.filtros.id_status_gestion.map(
              v => v.id
            );
          }
        } else {
          // copy['id_status_gestion__in'] = []
        }

        if (this.filtros.in_service_mains_distance) {
          copy.in_service_mains_distance__lte = this.filtros.in_service_mains_distance;
        }
      } catch (err) { }
      return copy;
    },
    filterArea () {
      if (!this.showOnly) {
        this.newLote.geom_geojson = this.getLayersJSON();
        this.getCount();
      }

      this.showModal();
    },
    getLayersJSON () {
      var geojsonarray = [];
      for (let i in this.$parent.$parent.map.drawerLayers) {
        let layer = this.$parent.$parent.map.drawerLayers[i];
        if (layer.toGeoJSON().geometry) {
          geojsonarray.push(JSON.stringify(layer.toGeoJSON().geometry));
        } else if (layer.toGeoJSON().features.length === 1) {
          geojsonarray.push(
            JSON.stringify(layer.toGeoJSON().features[0].geometry)
          );
        }
      }
      this.geometrias.numero_geometrias = geojsonarray.length;
      return geojsonarray;
    },
    saveLote () {
      if (this.newLote.metodo_lote_selected.id === 'Manual') {
        let type = 'comercial';
        if (this.newLote.tipo_lote_selected.id === 'CC') {
          type = 'caldera';
        }

        this.newLote.filtro_alfanumerico = '{}';

        this.newLote.fecha_inicio_prevista =
          this.newLote.fecha_inicio_prevista.split('+')[0] + '+00:00';
        this.newLote.fecha_cierre_prevista =
          this.newLote.fecha_cierre_prevista.split('+')[0] + '+00:00';

        this.newLote.tipo_lote = this.newLote.tipo_lote_selected.id;

        this.$http.post(type + '/createlote/', this.newLote).then(response => {
          if (response.data.result === 'Error') {
            alert(response.data.message);
          } else {
            this.clearFilters();
            this.loteForm = false;
            this.removeLayers();
          }
        });
      } else {
        let type = 'comercial';
        if (this.newLote.tipo_lote_selected.id === 'CC') {
          type = 'caldera';
        }

        let filtros = this.getFilters(type);
        if (Object.keys(filtros).length) {
          this.newLote.filtro_alfanumerico = JSON.stringify(filtros);
        } else {
          this.newLote.filtro_alfanumerico = '{}';
        }
        this.newLote.fecha_inicio_prevista =
          this.newLote.fecha_inicio_prevista.split('+')[0] + '+00:00';
        this.newLote.fecha_cierre_prevista =
          this.newLote.fecha_cierre_prevista.split('+')[0] + '+00:00';
        this.newLote.tipo_lote = this.newLote.tipo_lote_selected.id;

        this.$http.post(type + '/createlote/', this.newLote).then(response => {
          if (response.data.result === 'Error') {
            alert(response.data.message);
          } else {
            this.clearFilters();
            this.loteForm = false;
            this.removeLayers();
          }
        });
      }
    },
    saveEditedLote () {
      if (this.newLote.metodo_lote_selected.id === 'Manual') {
        let type = 'comercial';
        if (this.newLote.tipo_lote_selected.id === 'CC') {
          type = 'caldera';
        }

        this.newLote.metodo_lote = this.newLote.metodo_lote_selected.id;
        this.newLote.filtro_alfanumerico = '{}';

        this.newLote.tipo_lote = this.newLote.tipo_lote_selected.id;
        this.newLote.fecha_inicio_prevista =
          this.newLote.fecha_inicio_prevista.split('+')[0] + '+00:00';
        this.newLote.fecha_cierre_prevista =
          this.newLote.fecha_cierre_prevista.split('+')[0] + '+00:00';
        // this.newLote.status = 'Abierto'

        this.$http
          .post(type + '/' + this.newLote.id + '/editlote/', this.newLote)
          .then(response => {
            if (response.body.result === 'Error') {
              alert(response.body.message);
            } else {
              this.clearFilters();
              this.loteForm = false;
              this.edit = false;
              this.removeLayers();
            }
          });
      } else {
        let type = 'comercial';
        if (this.newLote.tipo_lote_selected.id === 'CC') {
          type = 'caldera';
        }

        let filtros = this.getFilters(type);
        if (Object.keys(filtros).length) {
          this.newLote.filtro_alfanumerico = JSON.stringify(filtros);
        }
        this.newLote.tipo_lote = this.newLote.tipo_lote_selected.id;
        this.newLote.fecha_inicio_prevista =
          this.newLote.fecha_inicio_prevista.split('+')[0] + '+00:00';
        this.newLote.fecha_cierre_prevista =
          this.newLote.fecha_cierre_prevista.split('+')[0] + '+00:00';
        // this.newLote.status = 'Abierto'

        this.$http
          .post(type + '/' + this.newLote.id + '/editlote/', this.newLote)
          .then(response => {
            if (response.body.result === 'Error') {
              alert(response.body.message);
            } else {
              this.clearFilters();
              this.loteForm = false;
              this.edit = false;
              this.removeLayers();
            }
          });
      }
    },
    comercialChanged: function () {
      this.loteGestionando.status = 'Abierto';
      this.loteGestionando.fecha_inicio_real = new Date();
      this.loteGestionando.fecha_inicio_prevista = this.$moment(
        this.loteGestionando.fecha_inicio_prevista,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DDThh:mm');
      this.loteGestionando.fecha_cierre_prevista = this.$moment(
        this.loteGestionando.fecha_cierre_prevista,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DDThh:mm');

      this.$http.put(
        'lotes/' + this.loteGestionando.id + '/',
        this.loteGestionando
      );
    },
    calderaChanged: function () {
      this.loteGestionando.status = 'Abierto';
      this.loteGestionando.fecha_inicio_real = new Date();
      this.loteGestionando.fecha_inicio_prevista = this.$moment(
        this.loteGestionando.fecha_inicio_prevista,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DDThh:mm');
      this.loteGestionando.fecha_cierre_prevista = this.$moment(
        this.loteGestionando.fecha_cierre_prevista,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DDThh:mm');

      this.$http.put(
        'lotes/' + this.loteGestionando.id + '/',
        this.loteGestionando
      );
    },
    gestionarLote (data) {
      var id = data.id;
      this.$http.get('lotes/' + id + '/gestionarlote/').then(response => {
        this.gestionandoLote = true;
        this.loteGestionando = data;
        this.$refs.modalLotes.hide();
        this.hideModalflag = true;

        if (response.body.id_comercial.filter(e => e !== null).length > 0) {
          this.$parent.setFilter(
            this.$parent.comercial,
            'id',
            response.body.id_comercial
          );
        } else {
          this.$parent.setFilter(
            this.$parent.caldera,
            'id',
            response.body.id_caldera
          );
        }

        if (data.metodo_lote === 'Parametrizado' && response.body.geom !== null) {
          this.$parent.$parent.map.map.fitBounds(
            new self.L.GeoJSON(JSON.parse(response.body.geom)).getBounds()
          );
        }

        this.loteGestion = id;
      });
    },
    cerrarLote (id) {
      this.cerrarlote_resumen = {};
      this.$http
        .get('lotes/' + id + '/resumencategoriavisitas/')
        .then(response => {
          this.cerrandoLote = true;
          this.$refs.modalLotes.hide();
          this.cerrarlote_resumen = response.body.categorias;
          this.$refs.modalCerrarLote.show();
          this.loteCerrado = id;
        });
    },
    hideCerrarLote () {
      this.$refs.modalCerrarLote.hide();
      if (this.confirmModal) {
        this.$refs.modalPreventCerrarLote.show();
      } else {
        this.$refs.modalLotes.show();
        this.cerrandoLote = false;
      }
    },
    showCerrarLoteConfirm () {
      this.confirmModal = true;
      // this.$refs.modalCerrarLote.hide()
      // this.$refs.modalPreventCerrarLote.show()
    },
    cerrarLoteConfirm () {
      this.$refs.modalPreventCerrarLote.hide();
      this.$http
        .post('lotes/' + this.loteCerrado + '/cerrarlote/')
        .then(response => {
          this.loteCerrado = '';
          this.$refs.table.refresh();
        });
    },
    hideModalPreventCerrar () {
      this.cerrandoLote = false;
      this.confirmModal = false;
      this.$refs.modalLotes.show();
    },
    exitGestion () {
      this.$parent.setFilter(this.$parent['comercial'], 'id', []);
      this.$parent.setFilter(this.$parent['caldera'], 'id', []);
      this.gestionandoLote = false;
      this.hideModalflag = false;
      var th = this;
      setTimeout(() => {
        th.$refs.modalLotes.show();
        th.loteGestion = '';
      }, 100);
    },
    editLote (id) {
      // this.categorias_en_poligono = {}
      this.$http.get('lotes/' + id + '/').then(result => {
        this.$set(this, 'newLote', result.body);
        this.$set(this.newLote, 'metodo_lote_selected', this.metodos_lotes.filter(
          e => e.id === this.newLote.metodo_lote
        )[0]);

        this.$set(this.newLote, 'tipo_lote_selected', this.tipos_lotes.filter(
          e => e.id === this.newLote.tipo_lote
        )[0]);
        // this.geometrias.numero_geometrias = this.newLote.num_geometrias
        // this.geometrias.numero_comerciales = this.newLote.num_comerciales
        let that = this;
        if (this.newLote.tipo_lote_selected.id === 'GC') {
          this.parseFiltrosComercial(
            JSON.parse(this.newLote.filtro_alfanumerico),
            function (cbr) {
              that.loteForm = true;
              that.loadUsersInLote();
              that.edit = true;
              that.showOnly = false;
              // that.categorias_en_poligono = that.newLote.dictresume
              that.$parent.$parent.setDrawerLayersFromLote(
                that.newLote.geom_geojson,
                false
              );
              that.getCount();
              that.$http
                .get('users/', {
                  params: { username: that.newLote.usuario_asignador }
                })
                .then(result => {
                  that.nombre_asignador =
                    result.data[0].first_name + ' ' + result.data[0].last_name;
                  that.getCount();
                  that.loadFinished = true;
                });
            }
          );
        } else {
          this.parseFiltrosCaldera(
            JSON.parse(this.newLote.filtro_alfanumerico)
          );
          this.loteForm = true;
          this.loadUsersInLote();
          this.edit = true;
          this.showOnly = false;
          // this.categorias_en_poligono = this.newLote.dictresume
          this.$parent.$parent.setDrawerLayersFromLote(
            this.newLote.geom_geojson,
            false
          );
          // this.getCount()
          this.$http
            .get('users/', {
              params: { username: this.newLote.usuario_asignador }
            })
            .then(result => {
              this.nombre_asignador =
                result.data[0].first_name + ' ' + result.data[0].last_name;
              this.getCount();
              this.loadFinished = true;
            });
        }
      });
    },
    getLote (id) {
      // this.categorias_en_poligono = {}
      this.$http.get('lotes/' + id + '/').then(result => {
        this.newLote = result.data;

        this.newLote.metodo_lote_selected = this.metodos_lotes.filter(
          e => e.id === this.newLote.metodo_lote
        )[0];

        this.newLote.tipo_lote_selected = this.tipos_lotes.find(
          e => e.id === result.data.tipo_lote
        );
        // this.newLote.tipo_lote = {id: 'comercial', label: 'Gran Consumo'}

        this.showOnly = true;
        this.geometrias.numero_geometrias = this.newLote.num_geometrias;

        // this.count_comerciales = this.newLote.num_comerciales
        let that = this;
        if (this.newLote.tipo_lote_selected.id === 'GC') {
          this.parseFiltrosComercial(
            JSON.parse(this.newLote.filtro_alfanumerico),
            function (cbr) {
              that.loteForm = true;
              that.loadUsersInLote();
              that.$parent.$parent.setDrawerLayersFromLote(
                that.newLote.geom_geojson,
                true
              );
              // that.getCount()
              // that.categorias_en_poligono = that.newLote.dictresume

              that.$http
                .get('users/', {
                  params: { username: that.newLote.usuario_asignador }
                })
                .then(result => {
                  that.nombre_asignador =
                    result.data[0].first_name + ' ' + result.data[0].last_name;
                  that.getCount();
                  that.loadFinished = true;
                  // that.getCount()
                });
            }
          );
        } else {
          this.parseFiltrosCaldera(
            JSON.parse(this.newLote.filtro_alfanumerico)
          );
          that.loteForm = true;
          that.loadUsersInLote();
          that.$parent.$parent.setDrawerLayersFromLote(
            that.newLote.geom_geojson,
            true
          );
          // that.getCount()
          // that.categorias_en_poligono = that.newLote.dictresume

          that.$http
            .get('users/', {
              params: { username: that.newLote.usuario_asignador }
            })
            .then(result => {
              that.nombre_asignador =
                result.data[0].first_name + ' ' + result.data[0].last_name;
              that.getCount();
              that.loadFinished = true;
              // that.getCount()
            });
        }
      });
    },
    parseFiltrosComercial (filtrosFromLote, cb) {
      // CLASE ESTABLECIMIENTO NEDGIA
      if ('id_clase_establecimiento_gn_comercial__in' in filtrosFromLote) {
        if (filtrosFromLote['id_clase_establecimiento_gn_comercial__in'].length > 0) {
          this.filtros.id_clase_establecimiento_gn_comercial = this.optsfiltros.id_clase_establecimiento_gn_comercial.filter(
            v =>
              v.id &&
              filtrosFromLote['id_clase_establecimiento_gn_comercial__in'].indexOf(v.id) > -1
          );
        }
      } else {
        // this.filtros.id_clase_establecimiento_gn_comercial = this.optsfiltros.id_clase_establecimiento_gn_comercial.filter(v => true)
      }

      // STATUS GESTIÓN
      if ('id_status_gestion__in' in filtrosFromLote) {
        if (filtrosFromLote['id_status_gestion__in'].length > 0) {
          this.filtros.id_status_gestion = this.optsfiltros.id_status_gestion.filter(
            v =>
              v.id &&
              filtrosFromLote['id_status_gestion__in'].indexOf(v.id) > -1
          );
        }
      } else {
        this.filtros.id_status_gestion = this.optsfiltros.id_status_gestion.filter(v => v.status === 'Todos');
      }

      // DISTANCIA
      if ('in_service_mains_distance__lte' in filtrosFromLote) {
        this.filtros['in_service_mains_distance'] = filtrosFromLote['in_service_mains_distance__lte'];
      } else {
        this.filtros['in_service_mains_distance'] = this.optsfiltros.in_service_mains_distance.find(v => v.label === 'Todos').id;
      }

      // CATEGORÍA ESTABLECIMIENTO + TIPO ESTABLECIMIENTO
      if ('id_categoria_gn_comercial__in' in filtrosFromLote) {
        if (filtrosFromLote['id_categoria_gn_comercial__in'].length > 0) {
          this.loadingtipos = true;

          var params = {
            params: {
              not_paginated: true,
              id_categoria_gn_comercial__in:
                filtrosFromLote['id_categoria_gn_comercial__in']
            }
          };

          this.$http.get('tipos_comercial/', params).then(result => {
            var tipos = result.body.map(tipo => {
              return { id: tipo.id, tipo: tipo.tipo };
            });

            this.filtros.id_categoria_gn_comercial = filtrosFromLote['id_categoria_gn_comercial__in'].map(id =>
              this.optsfiltros.id_categoria_gn_comercial.find(
                cat => cat.id === id
              )
            );

            if ('id_tipo_establecimiento_gn_comercial__in' in filtrosFromLote) {
              if (filtrosFromLote['id_tipo_establecimiento_gn_comercial__in'].length > 0) {
                let filter = filtrosFromLote['id_tipo_establecimiento_gn_comercial__in'];
                // this.optsfiltros.id_tipo_establecimiento_gn_comercial = []
                for (let index = 0; index < filter.length; index++) {
                  const element = filter[index];
                  var id = element;
                  if (id.constructor !== Number) {
                    id = parseInt(element.split('Todas ')[1]);
                    if (id && !isNaN(id)) {
                      let tipo =
                        'Todas ' +
                        this.optsfiltros.id_categoria_gn_comercial.find(
                          e => e.id === id
                        ).categoria_gn_comercial;
                      this.filtros.id_tipo_establecimiento_gn_comercial.push({
                        id: element,
                        tipo: tipo
                      });
                    }
                  } else {
                    id = element;
                    this.filtros.id_tipo_establecimiento_gn_comercial.push(
                      tipos.find(t => t.id === id)
                    );
                  }
                }
              }
            }
            this.optsfiltros.id_tipo_establecimiento_gn_comercial = tipos;
            this.loadingtipos = false;

            cb(true);
          });
        }
      } else {
        // this.filtros.id_categoria_gn_comercial = this.optsfiltros.id_categoria_gn_comercial.filter(cat => true)

        // let categorias = []

        // for (let index = 0; index < this.filtros.id_categoria_gn_comercial.length; index++) {
        //   const element = this.filtros.id_categoria_gn_comercial[index]
        //   categorias.push({
        //     id: 'Todas ' + element.id,
        //     tipo: 'Todas ' + element.categoria_gn_comercial
        //   })
        // }

        // this.filtros.id_tipo_establecimiento_gn_comercial = categorias

        // // Cargar opciones de Tipo establecimiento

        // let params = {
        //   params: {
        //     not_paginated: true,
        //     id_categoria_gn_comercial__in: this.filtros.id_categoria_gn_comercial.map(m => m.id).join(',')
        //   }
        // }

        // this.$http.get('tipos_comercial/', params).then(result => {
        //   let tipos = result.body.map(tipo => {
        //     return { id: tipo.id, tipo: tipo.tipo }
        //   })

        //   this.optsfiltros.id_tipo_establecimiento_gn_comercial = [ ...this.filtros.id_tipo_establecimiento_gn_comercial, ...tipos ]

        //   this.loadingtipos = false

        //   cb(true)
        // })

        // Fin cargar opciones de Tipo establecimiento

        this.loadingtipos = false;

        cb(true);
      }
    },
    parseFiltrosCaldera (filtrosFromLote) {
      console.log(filtrosFromLote);

      // DISTANCIA
      if ('in_service_mains_distance__lte' in filtrosFromLote) {
        this.filtros['in_service_mains_distance'] = filtrosFromLote['in_service_mains_distance__lte'];
      } else {
        this.filtros['in_service_mains_distance'] = this.optsfiltros.in_service_mains_distance.find(v => v.label === 'Todos').id;
      }

      // TIPO ESTABLECIMIENTO
      if ('id_tipo_establecimiento_gn_caldera__in' in filtrosFromLote) {
        if (filtrosFromLote['id_tipo_establecimiento_gn_caldera__in'].length > 0) {
          this.filtros.id_tipo_establecimiento_gn_caldera = this.parentoptsfiltroscaldera.id_tipo_establecimiento_gn_caldera.filter(
            v =>
              v.id &&
              filtrosFromLote['id_tipo_establecimiento_gn_caldera__in'].indexOf(v.id) > -1
          );
        }
      } else {
        // this.filtros.id_tipo_establecimiento_gn_caldera = this.parentoptsfiltroscaldera.id_tipo_establecimiento_gn_caldera.filter(v => true)
      }

      // STATUS GESTIÓN
      if ('id_status_gestion__in' in filtrosFromLote) {
        if (filtrosFromLote['id_status_gestion__in'].length > 0) {
          this.filtros.id_status_gestion = this.parentoptsfiltroscaldera.id_status_gestion.filter(
            v =>
              v.id &&
              filtrosFromLote['id_status_gestion__in'].indexOf(v.id) > -1
          );
        }
      } else {
        this.filtros.id_status_gestion = this.parentoptsfiltroscaldera.id_status_gestion.filter(v => v.status === 'Todos');
      }

      // CATEGORIA
      if ('id_categoria_gn_caldera__in' in filtrosFromLote) {
        if (filtrosFromLote['id_categoria_gn_caldera__in'].length > 0) {
          this.filtros.id_categoria_gn_caldera = this.parentoptsfiltroscaldera.id_categoria_gn_caldera.filter(
            v =>
              v.id &&
              filtrosFromLote['id_categoria_gn_caldera__in'].indexOf(v.id) > -1
          );
        }
      } else {
        // this.filtros.id_categoria_gn_caldera = this.parentoptsfiltroscaldera.id_categoria_gn_caldera.filter(v => true)
      }

      // CLASE ESTABLECIMIENTO NEDGIA
      if ('id_clase_establecimiento_gn_caldera__in' in filtrosFromLote) {
        if (filtrosFromLote['id_clase_establecimiento_gn_caldera__in'].length > 0) {
          this.filtros.id_clase_establecimiento_gn_caldera = this.parentoptsfiltroscaldera.id_clase_establecimiento_gn_caldera.filter(
            v =>
              v.id &&
              filtrosFromLote['id_clase_establecimiento_gn_caldera__in'].indexOf(v.id) > -1
          );
        }
      } else {
        // this.filtros.id_clase_establecimiento_gn_caldera = this.parentoptsfiltroscaldera.id_clase_establecimiento_gn_caldera.filter(v => true)
      }
    },
    loadUser: debounce(function (value) {
      if (value && !this.clickHappened) {
        this.$http
          .get('userssuggestions/', {
            params: {
              tipo_lote: this.newLote.tipo_lote_selected.id,
              nombre_largo__icontains: value.toUpperCase()
            }
          })
          .then(result => {
            this.names_suggestions = result.data.results;
            this.show_names = true;
          });
      } else {
        this.show_names = false;
      }
    }, 250),
    clearFilters () {
      this.filtros = {
        id_tipo_establecimiento_gn_comercial: [],
        id_categoria_gn_comercial: [],
        id_clase_establecimiento_gn_comercial: [],
        id_tipo_establecimiento_gn_caldera: [],
        id_categoria_gn_caldera: [],
        id_clase_establecimiento_gn_caldera: [],
        id_status_gestion: [],
        in_service_mains_distance: null
      };
      this.newLote = {
        tipo_lote: 'GC',
        tipo_lote_selected: { id: 'GC', label: 'Gran Consumo' },
        status: 'Creado',
        metodo_lote_selected: { id: 'Parametrizado', label: 'Parametrizado' },
        metodo_lote: 'Parametrizado',
        descripcion: '',
        usuario_asignador: this.user,
        fecha_inicio_prevista: '',
        fecha_cierre_prevista: '',
        usuario_asignado: '',
        filtro_manual: [],
        create_user: this.user,
        geom_geojson: []
      };
      // this.nombre_asignador = ''
      this.geometrias.numero_geometrias = 0;
      this.count_comerciales = 0;
      this.count_comerciales_in_geometry = 0;
      this.usuarioasignado = '';
    },
    loadUsersInLote () {
      this.$http
        .get('userssuggestions/', {
          params: { username: this.newLote.usuario_asignado }
        })
        .then(result => {
          this.setElement(result.body.results[0]);
        });
    },
    validateLote () {
      /* if (!this.geometrias.numero_geometrias) {
        alert('Debe seleccionar un área geográfica')
      } else */ if (
        (this.newLote.metodo_lote_selected.id === 'Parametrizado' && !this.count_comerciales_in_geometry) ||
        (this.newLote.metodo_lote_selected.id === 'Manual' && this.newLote.filtro_manual.length === 0)
      ) {
        alert('No puede guardar un lote vacío');
      } else {
        this.$validator.validate().then(result => {
          if (!result) {
            alert('Tienes algún error en el formulario');
          } else if (this.newLote.metodo_lote_selected.id === 'Parametrizado' && this.count_comerciales_in_geometry > 1000) {
            alert('El lote tiene muchos comerciales/calderas');
          } else {
            if (this.edit) {
              this.saveEditedLote();
            } else {
              this.saveLote();
            }
          }
        });
      }
    }
  },
  watch: {

    // newLote: {
    //   handler (val) {
    //     // do stuff
    //     console.log('A', val)
    //   },
    //   deep: true
    // }

    'newLote.tipo_lote_selected.id': function () {
      this.getCount();
    }
    // filtros: {
    //   handler: function (newValue) {
    //     if (this.loadFinished) {
    //       if (!this.showOnly) {
    //         this.getCount()
    //       }
    //     }
    //   },
    //   deep: true
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/LotesPopUp.vue